import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/lib/axios";
import { API_PORTAL_URL } from "@/lib/config";

export const insertWebLead = createAsyncThunk(
  "Website/InsertWebsiteLead",
  async (formdata: unknown) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Website/InsertWebsiteLead`,
        formdata,
      );
      return response.data?.Data;
    } catch (error: unknown) {
      const err = error as { response?: { data?: { Details?: string } } };
      console.error("Error submitting contact form:", error);
      return Promise.reject({
        message: err?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveFAQs = createAsyncThunk(
  "FAQ/FindAllActiveFAQ",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/FAQ/FindAllActiveFAQ`,
      );
      return response.data?.Data;
    } catch (error: unknown) {
      const err = error as { response?: { data?: { Details?: string } } };
      console.error("Error Fetching FAQs:", error);
      return Promise.reject({
        message: err?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
